module.exports = __webpack_public_path__ + "img/merchant.aec607ca.svg";